export enum KeyRefreshEnum {
  Farm = 'FARM-KEY-REFRESH',
  None = 'NO-KEY-REFRESH',
  PropertyProfile = 'PP-KEY-REFRESH'
}
